// @see https://github.com/DrupalizeMe/react-and-drupal-examples/tree/master/react-decoupled
// @see https://dev.acquia.com/blog/decoupled-drupal-authentication-oauth-20
export const propTypesSaleOpts = ['All Listings', 'Condominium', 'Income Property', 'Multi-Family', 'Single Family', 'Townhouse', 'Vacant Land', 'Villa'];
export const propTypesRentOpts = ['All Listings', 'Condominium', 'Multi-Family', 'Single Family', 'Townhouse', 'Villa'];
import {resetDefaultValuesRent as RentalSearchDefault} from '@/helpers/listing';
import {resetDefaultValuesBuy as BuySearchDefault} from '@/helpers/listing';

/**
 * OpenSolr client factory.
 *
 * @param {object} config
 *
 * @returns {object}
 *   Returns an object of functions with $config injected.
 */
export function getSolrClient(config = {}) {
  let map_vals = {
    txt: 't',
    prop_type: 'pt',
    price_min: 'pl',
    price_max: 'ph',
    city: 'c',
    neighbor: 'n',
    beds: 'bed',
    baths: 'bath',
    sort: 'sort',
  };
  let map_vals_api = {
    txt: 't',
    // prop_type: 'pt',
    price: 'p',
    // 'price[min]': 'pl',
    // 'price[max]': 'ph',
    city: 'c',
    community: 'n',
    'commTerm': 'n',
    beds: 'bed',
    baths: 'bath',
    bathAll: 'bath',
    sort: 'sort',
    pager: 'pager',
  };
  let sort_vals = {
    its_brokerage: 'feat',
    its_price: 'price',
  };

  /**
   * Convert search query into String from new values (as Object).
   * Will be set in Browser History.
   * @var new_vals: Object
   *
   * @return: String
   */
  function assembleJsonApiSearchShareQuery(new_vals, router) {
    let urlQueryArr = [], urlQueryStr = '';
    const url = new URL(router.asPath, process.env.NEXT_PUBLIC_FRONT_URL);

    Object.keys(map_vals_api).map(k => {
      if (new_vals[k] && new_vals[k] !== 0) {
        if (['beds', 'baths', 'community'].includes(k) && new_vals[k] != 0 && !isNaN(new_vals[k])) {
          urlQueryArr.push(`${map_vals_api[k]}=${new_vals[k]}`);
        }
        else if (['price'].includes(k)) {
          if (new_vals[k] !== 0) {
            urlQueryArr.push(`${map_vals_api[k]}=${new_vals[k]}`);
          }
        }
        else if (k == 'txt' && new_vals[k].length > 0) {
          urlQueryArr.push(`${map_vals_api[k]}=${encodeURI(new_vals[k])}`);
        }
      }
    });

    if (urlQueryArr?.length > 0) {
      urlQueryStr = `${process.env.NEXT_PUBLIC_FRONT_URL}${url.pathname}?${urlQueryArr.join('&')}`;
    }

    return urlQueryStr;
  }

  /**
   * Assemble Solr query as a string from provided data object.
   */
  function assembleQuery(new_vals) {
    let res = '', min_p = '', max_p = '', defaultValues={};
    let queryStringQ, queryStringFq = '', queryStringFl = '&fl=*',
      queryStringQF = '', sortString = '&sort=', queryStringFacet = '', vals;

    if (new_vals?.solrMltListings) {
      defaultValues = {
        index_id: 'eat_listings',
        internalId: '',
        index_hash: '5cwkwn',
        content_type: 'listing',
        skip_sold: true,
        content: 'entity:node/',
        lang: 'en',
        mlt_fields: `ss_sale_type,tm_X3b_en_city`,
        sort: [{dir: 'DESC', field: 'score'}, {dir: 'DESC', field: 'ds_modified'}],
        page: 0,
      };
      vals = {...defaultValues, ...new_vals};
      queryStringQ = `&mlt.fl=${vals.mlt_fields}&q=id:%22${vals.index_hash}-${vals.index_id}-${vals.content}${vals.internalId}:${vals.lang}%22`;
    }
    else {
      if (new_vals?.solrBoundaryPages) {
        defaultValues = {
          index_id: 'boundary_terms',
          content_type: 'boundary_page',
          sort: [{dir: 'DESC', field: 'ds_modified'}],
          page: 0,
        };
      }
      else {
        defaultValues = {
          index_id: 'eat_listings',
          content_type: 'listing',
          skip_sold: true,
          txt: '',
          type: '',
          prop_type: [0],
          price_min: 0,
          price_max: 0,
          city: ['all'],
          neighbor: ['all'],
          schools: ['all'],
          beds: 0,
          baths: 0,
          sort: [{dir: 'DESC', field: 'ds_modified'}],
          page: 0,
        };
      }
      vals = {...defaultValues, ...new_vals};

      queryStringFq += '&fq=index_id:' + vals.index_id + '&fq=ss_content_type:' + vals.content_type;

      if (new_vals?.solrBoundaryPages) {
        queryStringQ = 'q=*:*';
        queryStringFl = '&fl=score,ss_url,its_nid,id,ss_content_type,ss_uuid,ss_img_uri,ss_sale_type,tm_X3b_en_city_name,tm_X3b_en_neighbor_name,tm_X3b_en_comm_name,tm_X3b_en_school_name,tm_X3b_en_special_name,ss_boundary_type,its_brokerage,tm_X3b_en_body,tm_X3b_en_summary,sm_slides_uri';
      }
      else {
        queryStringQ = vals.txt ? 'q={!type=dismax%20q.op=AND%20qf=tm_X3b_en_body qf=tm_X3b_en_addr1 qf=tm_X3b_en_addr2 qf=tm_X3b_en_city qf=ss_zip v=%27' + vals.txt + '%27}' : 'q=*:*';

        queryStringFl = '&fl=score,ss_url,its_nid,id,ss_uuid,ss_img_uri,ss_sale_type,its_price,its_bed,its_bath_all,its_bath_full,its_bath_half,ss_zip,fts_lat,fts_lon,its_brokerage';
        queryStringFl += ',its_sale_status,tm_X3b_en_title,tm_X3b_en_addr1,tm_X3b_en_addr2,tm_X3b_en_city,tm_X3b_en_state';
        if (vals.type == 'Buy') {
          queryStringFl += ',fts_lot_acres,its_sqft,its_garage,ss_prop_type'
        }
        else {
          queryStringFl += ',its_sqft,its_market_days,ds_date_avail';
        }
      }
    }

    const MAXPRICE = vals.type == 'Buy' ? 5000000 : 10000;
    const MAXSQFT = vals.type == 'Buy' ? 6000 : 6000;
    let PROP_TYPE = propTypesSaleOpts;
    if (vals?.type == 'Rental') {
      PROP_TYPE = propTypesRentOpts;
    }
    const MAXYEAR = new Date().getFullYear();

    // If a list of fields to return was passed in, override:
    if (new_vals.solr_fields) {
      queryStringFl = `&fl=${Array.isArray(new_vals.solr_fields) ? new_vals.solr_fields.join(',') : new_vals.solr_fields}`;
    }

    if (vals.type) {
      queryStringFq += '&fq=ss_sale_type:"' + vals.type + '"';
    }

    // DO NOT INCLUDE "sold" listings (which can be published nodes in Drupal)
    // https://stackoverflow.com/questions/16743626/solr-filter-query-including-not-and-or
    if (vals.skip_sold) {
      queryStringFq += '&fq=(*:* AND -its_sale_status:3)';
    }

    if (vals.prop_type) {
      vals.prop_type = Array.isArray(vals.prop_type) ? vals.prop_type : [vals.prop_type];
      if (vals.prop_type && vals.prop_type[0] != 0 && vals.prop_type[0] != 'all') {
        let t = [];
        vals.prop_type.map((p) => {
          var v = isNaN(p) ? p : PROP_TYPE[p];
          if (v == 'Multi-Family') {
            t.push('%22Condo%20-%20Hotel%22');
            t.push('%22Condominium%22');
            t.push('%22Duplex%22');
            t.push('%22Half%20Duplex%22');
            t.push('%22Multi-Family%22');
            t.push('%22Quadruplex%22');
            t.push('%22Triplex%22');
          }
          else if (v == 'Single Family') {
            t.push('%22Farm%22');
            t.push('%22Manufactured%20Home%22');
            t.push('%22Mobile%20Home%22');
            t.push('%22Single%20Family%20Residence%22');
          }
          else {
            t.push('%22' + v + '%22');
          }
        });
        if (t.length > 0) {
          queryStringFq += '&fq=ss_prop_type:(' + t.join('%20OR%20') + ')';
        }
      }
    }
    if (vals.pool) {
      queryStringFq += '&fq=bs_pool:true';
    }
    if (vals.comm_pool) {
      queryStringFq += '&fq=bs_comm_pool:true';
    }
    if (vals.featured) {
      queryStringFq += '&fq=its_brokerage:1';
    }
    if (vals.waterfront) {
      queryStringFq += '&fq=bs_waterfront:true';
    }
    if (vals.fireplace) {
      queryStringFq += '&fq=bs_fireplace_yn:true';
    }
    if (vals.new_build) {
      queryStringFq += '&fq=bs_new_construction:true';
    }
    // Look up by Taxonomy term assigned (not its GEO value):
    if (vals.city) {
      vals.city = Array.isArray(vals.city) ? vals.city : [vals.city];
      if (vals.city && vals.city[0] && vals.city[0] != 0 && vals.city[0] != 'all') {
        if (!vals?.solrBoundaryPages) {
          queryStringFq += '&fq=its_city_tid:(' + vals.city.join('%20') + ')';
        }
      }
    }
    // Look up by Taxonomy term assigned (not its GEO value):
    if (vals.neighbor) {
      vals.neighbor = Array.isArray(vals.neighbor) ? vals.neighbor : [vals.neighbor];
      if (vals.neighbor && vals.neighbor[0] != 0 && vals.neighbor[0] != 'all') {
        queryStringFq += '&fq=its_neighbor_tid:(' + vals.neighbor.join('%20') + ')';
      }
    }
    // Look up by Taxonomy term assigned (not its GEO value):
    let schools_cond = '';
    if (vals.schools) {
      vals.schools = Array.isArray(vals.schools) ? vals.schools : [vals.schools];
      if (vals.schools && vals.schools[0] != 0 && vals.schools[0] != 'all') {
        schools_cond = '(' + vals.schools.join('%20OR%20') + ')';
        if (!vals?.solrBoundaryPages) {
          queryStringFq += '&fq=(its_el_school:' + schools_cond + '%20OR%20its_mid_school:' + schools_cond  + '%20OR%20its_h_school:' + schools_cond + ')';
        }
      }
    }

    if (vals.available_min || vals.available_max) {
      let range = (vals.available_min && vals.available_min != 0) ? '[' + vals.available_min + '%20TO%20' : '[*%20TO%20';
      range += (vals.available_max && vals.available_max != 0) ? vals.available_max + ']' : '*]';
      queryStringFq += '&fq=ds_date_avail:' + range;
    }
    else if (vals.available) {
      // queryStringFq += '&fq=its_sale_status:(1 OR 2)&fq=ds_date_avail:[*%20TO%20NOW]';
      // should return all properties that have Sale Status of “On Market”
      queryStringFq += '&fq=its_sale_status:(1)';
    }

    if (vals.market_recent && vals.market_recent.length > 0) {
      const mkt = {
        today: 'NOW/DAY',
        this_week: '[NOW-7DAYS/DAY%20TO%20*]',
        this_month: '[NOW-30DAYS/DAY%20TO%20*]'
      };
      queryStringFq += '&fq=ds_date_on_market:' + mkt[vals.market_recent];
    }

    if (vals.openhouse) {
      queryStringFq += '&fq=bs_oh_active:true&fq=ds_oh_date2:[NOW%20TO%20*]';
    }
    else if (vals.oh_dates_min && vals.oh_dates_max) {
      queryStringFq += '&fq=bs_oh_active:true&fq=ds_oh_date1:[*%20TO%20' + vals.oh_dates_max + ']&fq=ds_oh_date2[' + vals.oh_dates_max + '%20TO%20*]';
    }
    else if (vals.oh_dates_min || vals.oh_dates_max) {
      queryStringFq += '&fq=bs_oh_active:true';
      if (vals.oh_dates_min) {
        queryStringFq += '&fq=ds_oh_date1:[' + vals.oh_dates_min + '%20TO%20*]';
      }
      else if (vals.oh_dates_max) {
        queryStringFq += '&fq=ds_oh_date2:[NOW%20TO%20' + vals.oh_dates_max + ']';
      }
    }

    if ((vals.price_min !== undefined && vals.price_max !== undefined
      && vals.price_min != 0 && vals.price_min == vals.price_max)) {
      queryStringFq += '&fq=its_price:[' + vals.price_min + ' TO *]';
    }
    else if ((vals.price_min !== undefined && vals.price_max !== undefined && vals.price_min != vals.price_max)
      && (vals.price_min != 0 || vals.price_max != MAXPRICE)) {
      min_p = vals.price_min;
      max_p = (vals.price_max == MAXPRICE || (vals.price_min && vals.price_max == 0)) ? '*' : vals.price_max;
      queryStringFq += '&fq=its_price:[' + min_p + ' TO ' + max_p + ']';
    }

    if ((vals.sqft_min !== undefined && vals.sqft_max !== undefined
      && vals.sqft_min != 0 && vals.sqft_min == vals.sqft_max)) {
      queryStringFq += '&fq=its_sqft:[' + vals.sqft_min + ' TO *]';
    }
    else if ((vals.sqft_min !== undefined && vals.sqft_max !== undefined && vals.sqft_min != vals.sqft_max)
      && (vals.sqft_min != 0 || vals.sqft_max != MAXSQFT)) {
      min_p = vals.sqft_min;
      max_p = (vals.sqft_max == MAXSQFT || (vals.sqft_min && vals.sqft_max == 0)) ? '*' : vals.sqft_max;
      queryStringFq += '&fq=its_sqft:[' + min_p + ' TO ' + max_p + ']';
    }

    if ((vals.acres_min !== undefined && vals.acres_max !== undefined
      && vals.sqft_min != 0 && vals.sqft_min == vals.acres_max)) {
      queryStringFq += '&fq=fts_lot_acres:[' + vals.acres_min + ' TO *]';
    }
    else if ((vals.acres_min !== undefined && vals.acres_max !== undefined && vals.acres_min != vals.acres_max)
      && (vals.acres_min != 0 || vals.acres_max != 20)) {
      min_p = vals.acres_min;
      max_p = (vals.acres_max == 20 || (vals.acres_min && vals.acres_max == 0)) ? '*' : vals.acres_max;
      queryStringFq += '&fq=fts_lot_acres:[' + min_p + ' TO ' + max_p + ']';
    }

    if ((vals.year_min !== undefined && vals.year_max !== undefined
      && vals.year_min != 0 && vals.year_min == vals.year_max)) {
      queryStringFq += '&fq=its_year:[' + vals.year_min + ' TO *]';
    }
    else if ((vals.year_min !== undefined && vals.year_max !== undefined && vals.year_min != vals.year_max)
      && (vals.year_min != 0 || vals.year_max != MAXYEAR)) {
      min_p = vals.year_min;
      max_p = (vals.year_max == MAXYEAR || (vals.year_min && vals.year_max == 0)) ? '*' : vals.year_max;
      queryStringFq += '&fq=its_year:[' + min_p + ' TO ' + max_p + ']';
    }

    if (vals.beds && vals.beds != 0 && vals.beds != 'all') {
      queryStringFq += '&fq=its_bed:[' + vals.beds + ' TO *]';
    }
    if (vals.baths && vals.baths != 0 && vals.baths != 'all') {
      queryStringFq += '&fq=its_bath_all:[' + vals.baths + ' TO *]';
    }

    if ((vals.garage_min !== undefined && vals.garage_max !== undefined
      && vals.garage_min != 0 && vals.garage_min == vals.garage_max)) {
      queryStringFq += '&fq=its_garage:[' + vals.garage_min + ' TO *]';
    }
    else if ((vals.garage_min !== undefined && vals.garage_max !== undefined && vals.garage_min != vals.garage_max)
      && (vals.garage_min != 0 || vals.garage_max != 5)) {
      min_p = vals.garage_min;
      max_p = vals.garage_max == 5 ? '*' : vals.garage_max;
      queryStringFq += '&fq=its_garage:[' + min_p + ' TO ' + max_p + ']';
    }

    if (vals.geo_area?.length > 0) {
      queryStringFq += `&fq={!field f=rpts_coords}Intersects(${vals.geo_area})`;
    }

    // Sort order:
    if (!Array.isArray(vals.sort) && vals.sort.field) {
      vals.sort = [vals.sort];
    }
    if (Array.isArray(vals.sort) && vals.sort?.length) {
      var sort_arr = [];
      if (vals.type == 'Buy') {
      }
      else if (vals.type == 'Rental') {
        if (vals.sort[0]['field'] == 'its_brokerage') {
          sort_arr.push('ds_date_avail%20asc');
        }
      }

      vals.sort.map((s) => {
        sort_arr.push(s.field + '%20' + s.dir);

        if (vals.sort.length == 1 /*&& vals.sort[0]['field'] == 'its_brokerage'*/) {
          sort_arr.push('score%20desc');
          if (vals.sort[0]['field'] == 'its_brokerage') {
            sort_arr.push('its_price%20desc');
          }
        }
      });

      if (sort_arr.length > 0) {
        sortString += sort_arr.join('%2C%20');
      }
    }
    else {
      sortString += 'score%20desc';
    }

    res = queryStringQ + queryStringFq + queryStringFl + queryStringFacet + queryStringQF + sortString;
    return res;
  }

  /**
   * Convert search query from URL (intended for Solr) into compatible one for Search Form Default settings.
   *
   * @var url_query: Object
   *
   * @return: Object
   */
  function parseUrlViewQuery(url_query) {
    let new_query = {};

    Object.keys(map_vals_api).map(k => {
      if (url_query[map_vals_api[k]]?.length > 0) {
        if (['txt', 'prop_type', 'sort'].includes(k)) {
          let v = decodeURI(url_query[map_vals_api[k]]);
          if (k == 'txt') {
            new_query = {...new_query, [k]: url_query[map_vals_api[k]]}
          }
          else if (k == 'prop_type' && v.length > 0) {
            if (v.includes(',')) {
              let v_arr = v.split(','), v_new = [];
              v_arr.map((av) => {
                if (!isNaN(av)) {
                  v_new.push(parseInt(av));
                }
              });
              new_query = {...new_query, [k]: v_new};
            }
            else {
              new_query = {...new_query, [k]: [v]};
            }
          }
          else if (k == 'sort' && v.length > 0 && v.includes('_')) {
            let v_arr = v.split('_', 2);
            Object.keys(sort_vals).map(s => {
              if (sort_vals[s] == v_arr[1]) {
                new_query = {
                  ...new_query,
                  sort: [{field: s, dir: v_arr[0]?.toUpperCase()}]
                };
              }
            });
          }
        }
        else if (['price'].includes(k) && url_query[map_vals_api[k]]?.includes('_')) {
          new_query = {...new_query, [k]: url_query[map_vals_api[k]]};
          let prices = url_query[map_vals_api[k]].split('_');
          if (prices[1] === '0') {
            new_query = {
              ...new_query,
              'price[min]': prices[0],
            };
          }
          else {
            new_query = {
              ...new_query,
              'price[min]': prices[0],
              'price[max]': prices[1],
            };
          }
        }
        else if (['baths', 'bathAll'].includes(k) && !isNaN(url_query[map_vals_api[k]])) {
          new_query = {
            ...new_query,
            [k]: parseFloat(url_query[map_vals_api[k]])
          };
        }
        else if (!isNaN(url_query[map_vals_api[k]])) {
          if (parseInt(url_query[map_vals_api[k]]) !== 0) {
            new_query = {
              ...new_query,
              [k]: parseInt(url_query[map_vals_api[k]])
            };
          }
        }
      }
    })
    return new_query;
  }

  return {assembleQuery, parseUrlViewQuery, assembleJsonApiSearchShareQuery};
}
